"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./Button.less");

var _classnames = _interopRequireDefault(require("classnames"));

var _ButtonGroup = _interopRequireDefault(require("./ButtonGroup"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var noop = function noop() {};

var Button = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Button, _Component);

  var _super = _createSuper(Button);

  function Button(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Button);
    _this = _super.call(this, props);
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Button, [{
    key: "handleClick",
    value: function handleClick(e) {
      if (this.props.disabled) {
        return;
      }

      this.props.onClick(e);
      this.props.onSubmit(e);
    }
  }, {
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          className = _this$props.className,
          size = _this$props.size,
          block = _this$props.block,
          disabled = _this$props.disabled,
          type = _this$props.type;

      var buttonProps = _objectSpread(_objectSpread({}, this.props), {}, {
        className: (0, _classnames.default)('primitive-button', {
          'block': block
        }, (_classNames = {}, (0, _defineProperty2.default)(_classNames, className, className), (0, _defineProperty2.default)(_classNames, size, size), _classNames)),
        onClick: this.handleClick,
        disabled: disabled ? true : undefined,
        type: type
      });

      delete buttonProps.block;
      return /*#__PURE__*/_react.default.createElement("button", buttonProps, this.props.children);
    }
  }], [{
    key: "Group",
    get: function get() {
      return _ButtonGroup.default;
    }
  }, {
    key: "propTypes",
    value: function propTypes() {
      return {
        /**
         * The size of the button
         */
        size: _propTypes.default.oneOf(['smallest', 'small', '', 'large']),

        /**
         * Method invoked when the button is clicked
         */
        onClick: _propTypes.default.func,

        /**
         * Method invoked when the button is submitted
         */
        onSubmit: _propTypes.default.func,

        /**
         * Method invoked when the clearing
         */
        onClear: _propTypes.default.func,

        /**
         * Whether or not the button is disabled
         */
        disabled: _propTypes.default.bool,

        /**
         * Whether the button should display as a block level element
         */
        block: _propTypes.default.bool,

        /**
         * The type of button
         */
        type: _propTypes.default.oneOf(['button', 'submit', 'reset'])
      };
    }
  }, {
    key: "defaultProps",
    get: function get() {
      return {
        size: '',
        children: 'Done',
        className: 'secondary',
        type: undefined,
        onClick: noop,
        onSubmit: noop,
        disabled: false,
        block: false
      };
    }
  }]);
  return Button;
}(_react.Component);

exports.default = Button;